/**
 * Linearly interpolates between the numbers.
 * The interpolation is done from `a` to `b`, so a `t` of 0 will return the value of `a`. A `t` of 1 will return the value of `b`.
 * Unclamped, meaning that if 't' goes outside of the range of 0-1 values will be interpolated outside of the range `a` - `b`
 *
 * @param a start value return when `t` is 0
 * @param b end value returned when `t` is 1
 * @param t denotes where the interpolated number should be placed between  `a` and  `b`
 * @returns the interpolated number
 */
export function unclampedLerp(a: number, b: number, t: number): number {
  return a * (1 - t) + b * t;
}
